import { createFileRoute } from "@tanstack/react-router";
import { ParcelWeights } from "~/features/settings/parcel-settings";

export const Route = createFileRoute("/_app/settings/shipping")({ component: ShippingSettingsPage });

function ShippingSettingsPage() {
  return (
    <>
      <ParcelWeights />
    </>
  );
}
